// extracted by mini-css-extract-plugin
export var acitonButtons = "_ih-0";
export var additionalIcon = "_ih-f";
export var block = "_ih-1";
export var blockContent = "_ih-7";
export var blockDescription = "_ih-8";
export var blockIcon = "_ih-9";
export var blockTitle = "_ih-6";
export var border = "_ih-a";
export var center = "_ih-l";
export var edge = "_ih-b";
export var edgeLabel = "_ih-c";
export var edgePath = "_ih-d";
export var error = "_ih-e";
export var flowchart = "_ih-g";
export var flowchartContent = "_ih-h";
export var highlighted = "_ih-3";
export var hover = "_ih-4";
export var icon = "_ih-i";
export var left = "_ih-m";
export var navButton = "_ih-j";
export var navButtons = "_ih-k";
export var right = "_ih-n";
export var selected = "_ih-2";
export var small = "_ih-5";